export default __webpack_public_path__ + "static/media/mobile-menu.5493f566.svg";